import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Static/Header'
import Footer from './Static/Footer'
import Home from './Pages/Home';
import AdminPage from './Admin/AdminPage';
import BuyPage from './Pages/BuyPage';
import ScrolltoTop from './ScrolltoTop';
import Bestselling from './Pages/Bestselling';
import SubCategoryPage from './Pages/SubCategoryPage';



const AppRoutes = () => {
  return (
    <Router>
      <ScrolltoTop/>
         < Header/>
         <Routes>
                {/* Home Route */}
                <Route exact path="/" element={<Home/>} />
                 <Route path="/admin" element={<AdminPage />} />
          <Route path="/buy/:category" element={<BuyPage />} />
            <Route path="/" element={<Bestselling />} />
        <Route path="/subcategory/:subcategory" element={<SubCategoryPage />} />
          

            </Routes>
         <Footer/>
    </Router>
  )
}

export default AppRoutes